/* tslint:disable:only-arrow-functions */

import { BoughtThisSeasonProviderConfigArgs } from 'models-recommendation';

import {
  getPanelTrackingIdProperty,
  PanelTrackingIdConstants,
} from '../panel-tracking-id';

export const PANEL_TRACKING_PROPERTIES = {
  panelName: 'BoughtThisSeasonTestPanel',
  panelTrackingIdConstants: {
    page: 'md',
    location: '',
    type: 'hr',
    provider: 'nebp',
    cssVariant: '001',
  },
  panelTrackingIdConstantsExt: {
    values: [{ provider: 'self', property: 'panelTrackingIdConstants' }],
    transform: function ([constants]: [
      PanelTrackingIdConstants,
      BoughtThisSeasonProviderConfigArgs,
    ]) {
      constants.type = `${constants.type}`;
      return constants;
    }.toString(),
  },
  ...getPanelTrackingIdProperty({
    provider: 'self',
    property: 'panelTrackingIdConstantsExt',
  }),
};
